import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { fetchAppConfig } from '../services/configService';
import type { AppConfig } from '../services/configService';

const DEFAULT_CONFIG: AppConfig = {
  title: 'GraveSearch',
  clientName: 'GraveSearch',
};

const AppConfigContext = createContext<AppConfig>(DEFAULT_CONFIG);

function getCachedConfig(): AppConfig {
  const title = localStorage.getItem('appTitle');
  const clientName = localStorage.getItem('appClientName');
  if (title) {
    document.title = title;
    return { title, clientName: clientName ?? DEFAULT_CONFIG.clientName };
  }
  return DEFAULT_CONFIG;
}

export function AppConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<AppConfig>(getCachedConfig);

  useEffect(() => {
    fetchAppConfig().then((cfg) => {
      localStorage.setItem('appTitle', cfg.title);
      localStorage.setItem('appClientName', cfg.clientName);
      setConfig(cfg);
      document.title = cfg.title;
    });
  }, []);

  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useAppConfig(): AppConfig {
  return useContext(AppConfigContext);
}
